export const URL_BASE = "https://hallow.com";
